<template>
  <div class="job-detail-component">
    <div v-for="(item, index) in webpageItem" :key="index">
      <div v-if="item.type === 'silder'" class="preview-group-plane">
        <div class="preview-group">
          <div v-if="item.title" class="preview-title" v-html="item.title">
          </div>
          <template v-if="item.items !== undefined && item.items !== null && item.items.length > 1">
            <div class="swiper-container">
              <el-carousel :interval="isPCPreview ? 5000 : 3000" arrow="hover" indicator-position="outside" :height="carouselHeight + 'px'">
                <el-carousel-item class="swiper-wrapper" v-for="(element,index) in item.items"  :key="index">
                  <div v-if="element.target_url" class="swiper-slide">
                    <i class="middle_i" ></i>
                    <a target="_blank" :href="element.target_url.startsWith('http') ? element.target_url : 'http://' + element.target_url.trim()">
                      <img ref="swiperImg" @load="imgLoad($event,element.resource_key)" :src="qiniu_domian + element.resource_key">
                    </a>
                    <p v-html="element.description"></p>
                  </div>
                  <div v-else class="swiper-slide">
                    <i class="middle_i" ></i>
                    <a>
                      <img ref="swiperImg" @load="imgLoad($event,element.resource_key)" :src="qiniu_domian + element.resource_key">
                    </a>
                    <p v-html="element.description"></p>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
          </template>
          <template v-else>
            <div class="preview-silder-1">
              <a v-if="item.items[0].target_url" target="_blank" :href="item.items[0].target_url.startsWith('http') ? item.items[0].target_url : 'http://' + item.items[0].target_url.trim()">
                <img :src="qiniu_domian + item.items[0].resource_key">
              </a>
              <a v-else><img :src="qiniu_domian + item.items[0].resource_key"></a>
            </div>
            <div class="big-text-container" >
              <div class="preview-pic-text-1" >
                <span class="more-text-video" v-html="item.items[0].description" >
                </span>
                <span class="btn-more" @click="showMoreVideoDesc">{{ $t('jobDetail.expand') }}</span>
              </div>
            </div>
          </template>
        </div>
      </div>

      <div v-else-if="item.type === 'text'" class="preview-group-plane" >
        <div class="preview-group" >
          <div v-if="item.title" class="preview-title" v-html="item.title" >
          </div>
          <div class="big-text-container" >
            <div class="preview-text" >
              <span class="more-text" >{{ item.items[0].text }}</span>
              <span class="btn-more" @click="showMoreTextDesc($event)">{{ $t('jobDetail.expand') }}</span>
            </div>
          </div>
        </div>
      </div>

      <div v-else-if="item.type === 'video'" class="preview-group-plane smaller" >
        <div class="preview-group" >
          <div  v-if="item.title" class="preview-title" v-html="item.title">
          </div>
          <div class="preview-video">
            <div class="video-wrapper" >
              <video @ended="onVideoEnded($event,index)" x5-playsinline="" x-webkit-airplay="true" playsinline="true" webkit-playsinline="true" preload="auto" :poster="qiniu_domian + item.items[0].cover_resource_key">
              <source :src=" qiniu_domian + item.items[0].resource_key " type="video/mp4">
              <source :src=" qiniu_domian + item.items[0].resource_key " type="video/ogg">
              Your browser does not support the video tag.
              </video>
            </div>
            <div @click="onPlayIconClick($event,index)" :class="iconClass[index] ? 'play-icon icomoon-triangle' : 'play-icon' " ></div>
          </div>
          <div class="big-text-container" >
            <div class="preview-video-text" >
              <span class="more-text-video" v-html="item.items[0].description"></span>
              <span class="btn-more" @click="showMoreVideoDesc">
                {{ $t('jobDetail.expand') }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <template v-else-if="item.type === 'picture'">
        <div v-if="item.items !== undefined && item.items !== null && item.items.length === 1" class="preview-group-plane smaller" >
          <div class="preview-group" >
            <div v-if="item.title" class="preview-title" v-html=" item.title ">
            </div>
            <div class="preview-picture-1">
              <i class="middle_i" ></i>
              <a v-if="item.items[0].target_url" target="_blank" :href="item.items[0].target_url.startsWith('http') ? item.items[0].target_url : 'http://' + item.items[0].target_url.trim()">
                <img :src="qiniu_domian + item.items[0].resource_key">
              </a>
              <a v-else><img :src="qiniu_domian + item.items[0].resource_key"></a>
            </div>
            <div class="big-text-container" >
              <div class="preview-pic-text-1" >
                <span class="more-text-video" v-html=" item.items[0].description" >
                </span>
                <span class="btn-more" @click="showMoreVideoDesc($event)">
                  {{ $t('jobDetail.expand') }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div v-if="item.items !== undefined && item.items !== null && item.items.length !== 1" class="preview-group-plane smaller" >
          <div class="preview-group" >
            <div v-if="item.title" class="preview-title" v-html=" item.title ">
            </div>
            <div :class="item.items.length === 2 ? 'preview-picture-2' : 'preview-picture-3'">
              <template v-for="(element,index) in item.items">
                <div class="picture-comtainer" :key="index">
                  <div class="img-container">
                    <i class="middle_i" ></i>
                    <a v-if="element.target_url" target="_blank" :href="element.target_url.startsWith('http') ? element.target_url : 'http://' + element.target_url.trim()">
                      <img :src="qiniu_domian + element.resource_key">
                    </a>
                    <a v-else>
                      <img :src="qiniu_domian + element.resource_key">
                    </a>
                  </div>
                  <div class="big-text-container" >
                    <div>
                      <span class="more-text-video" v-html="element.description">
                      </span>
                      <span class="btn-more" @click="showMoreVideoDesc">
                        {{ $t('jobDetail.expand') }}
                      </span>
                    </div>
                  </div>
                </div>
              </template>
              <div class="clear"></div>
            </div>
          </div>
        </div>
      </template>

      <template v-else-if="item.type === 'job-detail-description'">
        <itemTemplate v-if="hasCustomize" :isPCPreview="isPCPreview" :hasCustomize='false' :webpageItem='headerItem' :languageCode="languageCode" :job="job"></itemTemplate>
        <div class="preview-group-plane job_des">
          <div class="jobdetail-wrapper-pc">
            <h4 v-if="isPCPreview">{{ $t('jobDetail.jobDescription') }}</h4>
            <div v-if="false" class="company-survey-entrance-job-detail">
              <span v-if="has_answered" class="iconfont iconcandidatesurvey-24 company-customized"></span>
              <span v-else class="iconfont iconcandidatesurvey-23 shake-bell"></span>
            </div>
          </div>
          <div class="preview-group" :class="isPCPreview ? 'content' : ''">
            <p>{{ job.i18n_name || getI18nPropertyValue(job, 'cn_title', 'title') }}</p>
            <span v-html="getI18nPropertyValue(job, 'cn_description', 'description')"></span>
            <img v-if="isInRootCompanyIdCustomizedArray" class="customized-img" :src="$DjangoStaticUrl(`image/marketing/jd_customized/${job.root_company_id}-mob-img.png`)"/>
          </div>
        </div>
        <itemTemplate v-if="hasCustomize" :isPCPreview="isPCPreview" :hasCustomize='false' :webpageItem='footerItem' :languageCode="languageCode" :job="job"></itemTemplate>
      </template>
    </div>
  </div>
</template>

<script>
import {
  QINIU_DOMAIN,
  JD_CUSTOMIZED_IMAGE_ROOT_COMPANY_IDS
} from '@/constant/common'
import { getI18nPropertyValue } from '@/i18n'
import { deviceType } from '@/utils/common'
import _ from 'lodash'

export default {
  props: {
    hasCustomize: {
      type: Boolean,
      required: true
    },
    webpageItem: {
      type: Array,
      required: true
    },
    languageCode: {
      type: String,
      required: true
    },
    job: {
      type: Object,
      default: null,
      required: true
    },
    isPCPreview: {
      type: Boolean,
      default: false
    },
    show_survey_entrance: {
      type: Boolean,
      default: false
    },
    has_answered: {
      type: Boolean,
      default: false
    },
    headerItem: {
      type: Array,
      default: () => []
    },
    footerItem: {
      type: Array,
      default: () => []
    }
  },
  name: 'itemTemplate',
  data () {
    return {
      qiniu_domian: QINIU_DOMAIN,
      isInRootCompanyIdCustomizedArray: false,
      iconClass: {},
      carouselHeight: 300,
      hasSetCarouselHeight: false,
      getI18nPropertyValue
    }
  },
  computed: {
    listenWebpageItem () {
      return this.webpageItem
    }
  },
  created () {
    if (this.webpageItem) {
      this.webpageItem.forEach((element, index) => {
        this.$set(this.iconClass, index, true)
      })
    } else {
      this.iconClass = {}
    }
    if (JD_CUSTOMIZED_IMAGE_ROOT_COMPANY_IDS.indexOf(Number(this.job.root_company_id)) > -1) {
      this.isInRootCompanyIdCustomizedArray = true
    } else {
      this.isInRootCompanyIdCustomizedArray = false
    }
  },
  methods: {
    html2Escape (sHtml) {
      return sHtml.replace(/[<>&"]/g, function (c) { return { '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;' }[c] })
    },
    onPlayIconClick (e, index) {
      const target = e.currentTarget
      const video = target.previousElementSibling.getElementsByTagName('video')[0]
      if (video.paused) {
        video.style.backgroundImage = 'url()'
        this.$set(this.iconClass, index, false)
        video.play()
        if (!video.getAttribute('controls')) {
          video.setAttribute('controls', 'true')
        }
      } else {
        this.$set(this.iconClass, index, true)
        video.pause()
      }
    },
    imgLoad ($event, src) {
      let width = document.body.clientWidth
      if (deviceType.isPc) {
        width = 375
      }
      if (width >= 750) {
        width = width - 80
      } else {
        width = width - 40
      }
      const img = new Image()
      img.src = this.qiniu_domian + src
      if (img.complete) {
        this.getCarouselHeight(width, img)
      }
      img.onload = () => {
        this.getCarouselHeight(width, img)
      }
      if (this.isPCPreview) {
        const swiperImg = this.$refs.swiperImg
        _.forEach(swiperImg, (item, index) => {
          const marginTop = (item.clientHeight - 300) / 2
          swiperImg[index].style.marginTop = -marginTop + 'px'
        })
      }
    },
    getCarouselHeight (width, img) {
      const height = (width / img.width) * img.height
      if (height > 0 && !this.hasSetCarouselHeight) {
        this.carouselHeight = height
        this.hasSetCarouselHeight = true
      }
      if (height > this.carouselHeight && this.hasSetCarouselHeight) {
        this.carouselHeight = height
      }
      if (this.isPCPreview) {
        this.carouselHeight = 300
      }
    },
    onVideoEnded (e, index) {
      const video = e.currentTarget
      video.style.height = window.getComputedStyle(video, null).getPropertyValue('height')
      video.load()
      video.attributes.removeNamedItem('controls')
      this.$set(this.iconClass, index, true)
    },
    showMoreTextDesc (e) {
      const dom = e.currentTarget
      const falg = dom.previousElementSibling.classList.length > 1
      if (falg) {
        dom.previousElementSibling.classList.remove('overflow-line-video')
        dom.innerHTML = this.$t('jobDetail.collapse')
      } else {
        dom.previousElementSibling.classList.add('overflow-line-video')
        dom.innerHTML = this.$t('jobDetail.expand')
      }
    },
    showMoreVideoDesc (e) {
      const dom = e.currentTarget
      const falg = dom.previousElementSibling.classList.length > 1
      if (falg) {
        dom.previousElementSibling.classList.remove('overflow-line-text')
        dom.innerHTML = this.$t('jobDetail.collapse')
      } else {
        dom.previousElementSibling.classList.add('overflow-line-text')
        dom.innerHTML = this.$t('jobDetail.expand')
      }
    }
  },
  watch: {
    listenWebpageItem (val) {
      if (this.webpageItem) {
        this.webpageItem.forEach((element, index) => {
          this.$set(this.iconClass, index, true)
        })
      } else {
        this.iconClass = {}
      }
      this.$nextTick(() => {
        const moreTextVideo = document.querySelectorAll('.more-text-video')
        moreTextVideo.forEach(item => {
          const h1 = item.clientHeight
          item.classList.add('overflow-line-video')
          const h2 = item.clientHeight
          if (h1 > h2) {
            item.nextElementSibling.style.display = 'block'
          }
        })
        const moreText = document.querySelectorAll('.more-text')
        moreText.forEach(item => {
          const h1 = item.clientHeight
          item.classList.add('overflow-line-text')
          const h2 = item.clientHeight
          if (h1 > h2) {
            item.nextElementSibling.style.display = 'block'
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>

  .overflow-line-video {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }

  .overflow-line-text {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 12;
    overflow: hidden;
  }

  .btn-more:hover{
    cursor: pointer;
  }

  .btn-more{
    display: none;
    float: right;
    font-size: 14px;
    margin-right: 7px;
    margin-top: 5px;
    color:#0096cc;
  }

.job-detail-component {

  .swiper-container .swiper-slide {
    height: 100%;
  }

  .preview-group-plane .preview-picture-1 {
      max-width: 100%;
      max-height: 140px;
      vertical-align: middle;
  }

  .preview-silder-1 {
      width: 100%;
      max-height: calc(100vh - 50px);
      max-height: -moz-calc(100vh - 50px);
      max-height: -webkit-calc(100vh - 50px);
  }

  .preview-silder-1 img {
      width: 100%;
  }

  .preview-group-plane .preview-pic-text-1{
      color: #888;
      font-size: 14px;
      line-height: 25px;
      margin-top: 8px;
  }

  .preview-group-plane .preview-picture-2 .picture-comtainer {
      width: 50%;
      float: left;
      text-align: -webkit-center;
  }

  .preview-group-plane .preview-picture-2 .img-container {
      width: 80%;
      height: 140px;
  }

  .preview-group-plane .img-container {
      margin-bottom: 10px;
  }

  .preview-group-plane .preview-picture-2 .img-container img {
      max-width: 100%;
      max-height: 100%;
      vertical-align: middle;
  }

  .preview-group-plane .preview-picture-2 span {
      color: #888;
      font-size: 10px;
      line-height: 15px;
      width: 100%;
      text-align: center;
      margin: 2% 0 0 0;
  }

  .preview-group-plane .preview-picture-3 .picture-comtainer {
      width: 33%;
      float: left;
      text-align: -webkit-center;
  }

  .preview-group-plane .preview-picture-3 .img-container{
      width: 80%;
      height: 0;
      vertical-align: middle;
      height: 96px;
      text-align: center;
  }

  .preview-group-plane .preview-picture-3 .img-container img {
      max-width: 100%;
      max-height: 100%;
      vertical-align: middle;
  }

  .preview-group-plane .preview-picture-3 span {
      color: #888;
      font-size: 10px;
      line-height: 15px;
      width: 100%;
      text-align: center;
      margin: 2% 0 0 0;
  }

  .preview-group-plane .preview-picture-3 .big-text-container {
      padding: 0 3px;
  }

  .preview-group-plane .preview-picture-2 .big-text-container {
      padding: 0 10px;
  }

  .preview-container .power-foot {
      background-color: #f7f7f7;
      height: 50px;
      color: #bbb;
      font-size: 12px;
      line-height: 50px;
      text-align: center;
  }

  .preview-container .foot {
      position: fixed;
      left: 0;
      bottom: 0;
      height: 50px;
      width: 100%;
      border-top: 1px solid #ddd;
      background-color: #fff;
      z-index: 1000;
      padding-bottom: constant(safe-area-inset-bottom); /* compatible with iOS version that less than 11.2 */
      padding-bottom: env(safe-area-inset-bottom); /* compatible with iOS version that greater than or equal to 11.2 */
  }

  .preview-container .foot .foot-item-3 {
      width: 33%;
      height: 50px;
      font-size: 16px;
      line-height: 50px;
      text-align: center;
      float: left;
      box-sizing: border-box;
  }

  .preview-container .foot div + div {
      border-left: 1px solid #ddd;
  }

  .preview-container .foot .foot-item-2 {
      width: 49.5%;
      height: 50px;
      font-size: 16px;
      line-height: 50px;
      text-align: center;
      float: left;
      box-sizing: border-box;
  }

  .preview-container .foot a {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 100%;
      display: block;
      padding: 0 10px;
      box-sizing: border-box;
  }

  .job_des {
    .jobdetail-wrapper-pc {
      position: relative;
      background-color: #fff;
      h4 {
        display: inline-block;
        color: #333;
        font-size: 24px;
        font-weight: normal;
        margin: 40px 0 14px;
        padding-left: 16px;
      }

      .company-survey-entrance-job-detail {
        position: absolute;
        right: -8px;
        bottom: -12px;

        .iconcandidatesurvey-24, .iconcandidatesurvey-23 {
          font-size: 24px;
        }
      }
    }

    .content {
      background-color: #fafafa;
      color: #666;
      padding: 20px 20px 20px 30px;
      border: 1px solid #f0f0f0;
      font-size: 16px;
      padding: 15px;

      ::v-deep p {
        margin: 0;
      }
    }
  }

  .job_des h4 {
    display: inline-block;
    color: #333;
    font-size: 24px;
    font-weight: normal;
    margin: 40px 0 14px;
    padding-left: 16px;
  }
}
</style>
